import React from 'react';
import parse from 'html-react-parser';

export default function ServiceDetail(props) {
    const service = props.item;
    const setShowPopup = props.setShowPopup;

    return (
        <div className="service-detail" style={{cursor:"pointer"}} onClick={()=>setShowPopup(service.serviceId)}>
            <div className="top">
                <div className="img" style={{ backgroundImage: "url('/documents/"+JSON.parse(service.icon).groupId+"/"+JSON.parse(service.icon).uuid+ "')" }}>
                </div>
                <h5>
                    {
                        service.subTitle
                    }
                </h5>
            </div>
            <div className="bottom">
                <h4>
                    {service.title}
                </h4>
                <div>
                    {parse(atob(service.description))}
                </div>
            </div>
        </div>
    );
}